import { render } from "./ProjectList.vue?vue&type=template&id=d037b2b8&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=d037b2b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d037b2b8"],['__file',"src/views/qywx/crm/project/ProjectList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d037b2b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d037b2b8', __exports__)) {
    api.reload('d037b2b8', __exports__)
  }
  
  module.hot.accept("./ProjectList.vue?vue&type=template&id=d037b2b8&scoped=true", () => {
    api.rerender('d037b2b8', render)
  })

}


export default __exports__